export default {
  storyboardScreens: [
    {
      imageFile: "01 See_651px.jpg",
      title: "Product Discovery",
      text: "Click next to discover how Lisa buys the dress of her dreams.",
      coordinates: { left: "", top: "", right: "", bottom: "" },
      screenId: "S01",
      hasNext: true,
      highlightPosition: "Top-Left"
    },
    {
      imageFile: "01a_Pinterest_651px.jpg",
      title: "On Social Media",
      text:
        "A day after the show, Lisa went on Pinterest. Lucia+Daniel use Pinterest for product placement and marketing.",
      coordinates: { left: "424", top: "112", right: "430", bottom: "0" },
      screenId: "S01a",
      hasNext: false,
      highlightPosition: "Top-Right"
    },
    {
      imageFile: "01b_Pinterest_651px.jpg",
      title: "On Social Media",
      text:
        "So Lisa finds the Lucia+Daniel's dress and pins it to her collection.<br/><br/>When she clicks through...",
      coordinates: { left: "443", top: "555", right: "451", bottom: "69" },
      screenId: "S01b",
      hasNext: false,
      highlightPosition: "Top-Right"
    },
    {
      imageFile: "01c See_651px.jpg",
      title: "Product Website",
      text:
        "…she is taken to Lucia+Daniel’s home page, where the dress is prominently displayed, thanks to the personalization tools they use.",
      coordinates: { left: "151", top: "207", right: "704", bottom: "71" },
      screenId: "S01c",
      hasNext: false,
      highlightPosition: "Top-Right"
    },
    {
      imageFile: "01d See_651px.jpg",
      title: "Exploring the Product",
      text:
        "She clicks to explore the Fall 2018 collection and the dress is displayed there, too.",
      coordinates: { left: "563", top: "185", right: "177", bottom: "60" },
      screenId: "S01d",
      hasNext: false,
      highlightPosition: "Top-Right"
    },
    {
      imageFile: "01e See_651px.jpg",
      title: "Exploring the Product",
      text:
        "Lisa views product information about the dress. She isn’t ready to spend that much money, but she still loves the dress.",
      coordinates: { left: "485", top: "231", right: "278", bottom: "300" },
      screenId: "S01e",
      hasNext: false,
      highlightPosition: "Top-Right"
    },
    {
      imageFile: "01f See_651px.jpg",
      title: "Making the Conversion",
      text:
        "Lucia+Daniel recognizes that the buying journey begins with browsing. They encourage Lisa to register for their list.",
      coordinates: { left: "420", top: "395", right: "420", bottom: "216" },
      screenId: "S01f",
      hasNext: false,
      highlightPosition: "Top-Right"
    },
    {
      imageFile: "01g See_651px.jpg",
      title: "Making the Conversion",
      text: "Lisa goes for it! She provides some basic information...",
      coordinates: { left: "161", top: "190", right: "643", bottom: "137" },
      screenId: "S01g",
      hasNext: false,
      highlightPosition: "Top-Right"
    },
    {
      imageFile: "01h See_651px.jpg",
      title: "Making the Conversion",
      text: "... and confirms her consent.",
      coordinates: { left: "188", top: "524", right: "669", bottom: "100" },
      screenId: "S01h",
      hasNext: false,
      highlightPosition: "Top-Right"
    },
    {
      imageFile: "01i See_651px.jpg",
      title: "Making the Conversion",
      text:
        "Lisa accepts Lucia+Daniel’s data policies as a final step and is now officially a part of the Lucia+Daniel fan club.",
      coordinates: { left: "448", top: "486", right: "447", bottom: "139" },
      screenId: "S01i",
      hasNext: false,
      highlightPosition: "Top-Right"
    }
  ]
};
